import { TranslationKeys } from "./en";

export const deTranslation: TranslationKeys = {
    nav: {
        profile: "Profil",
        logout: "Abmelden",
        open_settings: "Einstellungen öffnen",
    },
    common: {
        loading: "Laden",
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        loadMore: "Mehr laden",
        loadNext: "Nächste Seite",
        loadPrev: "Vorherige Seite",
        none: "Keine",
        search: "Suchen",
        clear: "Löschen",
        info: "Info",
        saved: "Erfolgreich gespeichert",
        save: "Speichern",
        remove: "Entfernen",
        clone: "Klonen",
        copied: "In die Zwischenablage kopiert",
        id: "ID",
    },
    login: {
        sign_in: "Anmelden",
        sign_in_with_google: "Mit Google anmelden",
        password: "Passwort",
        email_address: "E-Mail-Adresse",
        forgot_pass: "Passwort vergessen?",
        recovery: {
            title: "Passwort vergessen?",
            description:
                "Bitte gib die E-Mail-Adresse ein, mit der du dich anmeldest. Wir senden dir eine E-Mail mit Anweisungen zum Zurücksetzen deines Passworts.",
            submit: {
                title: "Passwort zurücksetzen",
                in_progress: "Verbindung wird hergestellt",
            },
            sent_description: "Wir haben dir eine E-Mail mit einem Link zum Zurücksetzen deines Passworts geschickt.",
            reset_description: "Lege ein neues Passwort für dein Konto fest.",
            no_email:
                "Falls du keine E-Mail erhalten hast: Prüfe, ob die E-Mail in deinem Spam-Ordner gelandet ist oder ob die eingegebene E-Mail-Adresse eventuell falsch war.",
            password_too_weak: "Passwort ist zu schwach.",
        },
    },
    errors: {
        unknown_error: "Unbekannter Fehler",
        invalid_email_or_password: "Ungültige E-Mail oder Passwort",
        invalid_auth_token: "Ungültiger Authentifizierungstoken",
        invalid_google_auth_code: "Ungültiger Google-Authentifizierungscode",
        entity_cannot_be_deleted:
            "Dieses Element kann leider nicht gelöscht werden, da zugehörige Daten in der Datenbank existieren.",
    },
    dashboard: {
        location_view: "Standortansicht",
        agent_list: "Agentenliste",
        location: "Standort",
        tenant: "Mandant",
        agency: "Agentur",
        total_agents: "Agenten gesamt",
        made_calls_agents_yesterday: "Agenten mit Anrufen (Gestern)",
        made_calls_agents_last_week: "Agenten mit Anrufen (1 Woche)",
        made_calls_agents_last_month: "Agenten mit Anrufen (1 Monat)",
        made_calls_agents_last_3_months: "Agenten mit Anrufen (3 Monate)",
        active_agents_yesterday: "Aktive Agenten (Gestern)",
        active_agents_1_week: "Aktive Agenten (1 Woche)",
        active_agents_1_month: "Aktive Agenten (1 Monat)",
        active_agents_3_months: "Aktive Agenten (3 Monat)",
        agent_name: "Agentenname",
        agent_email: "Agenten-EMail",
        agent_company_username: "Agent-Login",
        team: "Team",
        created: "Erstellt",
        last_login: "Letzte Anmeldung",
        last_call: "Letzter Anruf",
        daily_active_agents: "Tägliche Agenten mit Anrufen",
        export_data: "Daten exportieren",
        export_csv: "CSV herunterladen",
        copy_tsv: "TSV kopieren",
        scorecards: {
            active_agents_yesterday: "Agenten mit Anrufen (Gestern)",
            active_agents_last_week: "Agenten mit Anrufen (1 Woche)",
            active_agents_last_month: "Agenten mit Anrufen (1 Monat)",
            active_agents_last_3_months: "Agenten mit Anrufen (3 Monate)",
            made_calls_agents_yesterday: "Anrufe (Gestern)",
            made_calls_agents_last_week: "Anrufe (1 Woche)",
            made_calls_agents_last_month: "Anrufe (1 Monat)",
            made_calls_agents_last_3_months: "Anrufe (3 Monate)",
            total_agents: "Gesamtanzahl der Agenten",
        },
        agent_filters_title: "Agentenfilter",
        agent_filters: {
            all: "Alle",
            active_yesterday: "Gestern aktiv",
            active_last_week: "In der letzten Woche aktiv",
            active_last_month: "Im letzten Monat aktiv",
            active_last_3_month: "In den letzten 3 Monaten aktiv",
            inactive_yesterday: "Gestern inaktiv",
            inactive_last_week: "In der letzten Woche inaktiv",
            inactive_last_month: "Im letzten Monat inaktiv",
            inactive_last_3_month: "In den letzten 3 Monaten inaktiv",
            never_logged_in: "Noch nie eingeloggt",
        },
    },
};
